import React, { FC, memo, useCallback, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import * as yup from 'yup'
import { toast } from 'react-toastify'
import { Controller, useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

import { PrivacyPolicyModal } from 'components/PrivacyPolicyModal'

import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { InputField } from 'components/InputField'
import { ButtonMUI } from 'components/ButtonMUI'

// @ts-ignore
import jsonp from 'jsonp'
import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'


interface IProps {
}

export interface IConnectWithUsForm {
  email: string;
}

const schema = yup.object().shape({
  email: yup.string().email().required('Email should be required please')
})

const ConnectWithUsSection: FC<IProps> = props => {
  const { loadingStore, accountStore } = useStore()
  const [isAccept, setIsAccept] = useState(false)

  const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IConnectWithUsForm>({
    resolver: yupResolver(schema)
  })

  const resetFormData = () => {
    reset()
  }

  const handleChangeAccept = () => {
    setIsAccept(prev => !prev)
  }

  const onSubmit = async (data: IConnectWithUsForm) => {
    if (!isAccept) return

    try {
      loadingStore.setLoading(true)
      const getAjaxUrl = (url: string) => url.replace('/post?', '/post-json?')
      jsonp(`${getAjaxUrl(process.env.REACT_APP_MAILCHIMP || '')}&EMAIL=${data.email}`, {
        param: 'c',
        timeout: 0
      }, async (err: any, data: any) => {
        if (err) {
          toast.error(err)
          console.log('error', err)
          loadingStore.setLoading(false)
        } else if (data.result !== 'success') {
          toast.error(data.msg)
          console.log('error', data.msg)
          loadingStore.setLoading(false)
        } else {
          toast.success(data.msg)
          // console.log('success', data.msg)
          resetFormData()
          await sendEmailToServer(data.email)
          loadingStore.setLoading(false)
        }
      })
      // await sendEmailToServer(data.email)
      // toast.success('You have successfully subscribed')
      // resetFormData()
      // loadingStore.setLoading(false)
    } catch (error: any) {
      loadingStore.setLoading(false)
      toast.error(error.message ?? 'Something went wrong. Please try again')
      console.log('error', error)
    }
  }

  const sendEmailToServer = async (email: string) => {
    try {
      await accountStore.subscribeMailing(email)
    } catch (error: any) {
      console.log('error', error)
    }
  }

  return (
    <SectionContainer withBackgroundImage
                      style={{ backgroundImage: `linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 29.69%, rgba(0, 0, 0, 0.19) 59.37%, #000 100%), url(${staticMultimedia.connectSectionBG})` }}>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch' }}>
        <div className={styles.connectContainer}>
          <TitleSection title={'Connect with Us'}
                        subTitle={'Stay connected to Somnium Space updates'}/>
          <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <div className={styles.description}>
              Be the First to Know: Subscribe our Mailing List and be part of the inner circle. Get exclusive updates,
              behind-the-scenes insights, and early access to exciting news directly in your inbox. Don't miss a beat in
              the ever-evolving world of Somnium Space.
            </div>
            <div className={styles.inputsBlock}>
              <InputField name={'email'}
                          placeholder={'Email Address*'}
                          control={control}
                          errors={errors}/>
              <ButtonMUI styleType="blue"
                         type={'submit'}
                         disabled={!isAccept}
              >Subscribe
              </ButtonMUI>
            </div>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleChangeAccept}
                  sx={{
                    color: '#1474B8'
                  }}
                />
              }
              label={<div className={styles.acceptLabel}>
                I accept Somnium Space <PrivacyPolicyModal>
                {onOpen => <a onClick={event => {
                  event.stopPropagation()
                  event.preventDefault()
                  onOpen()
                }}>Privacy Policy</a>}</PrivacyPolicyModal>
              </div>}
              sx={{
                color: '#ffffff',
                marginRight: 0
              }}
            />
          </form>
        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(ConnectWithUsSection)
